var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VirtualScrollTable',{attrs:{"columns":_vm.columns,"data":_vm.subordinatesData,"columnHiddenOption":_vm.columnHiddenOption,"max-height":380,"checkbox-option":_vm.checkboxOption,"show-header":!_vm.isReadOnlyList}})}
var staticRenderFns = []

export { render, staticRenderFns }